<template>
  <div class="alert-contacts-page-wrapper">
    <!-- <Breadcrumbs main="" title="Alert Contacts" /> -->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
            <div class="alert-contacts-header">
              <!-- Search Bar Row -->
              <b-row class="mb-3">
                <b-col md="4">
                  <div class="alert-contacts-search-wrapper">
                    <b-input-group>
                      <b-input-group-prepend>
                        <span class="input-group-text search-icon">
                          <i class="icofont icofont-search-alt-2"></i>
                        </span>
                      </b-input-group-prepend>
                      <b-form-input
                        class="alert-contacts-search-input"
                        v-model="filter"
                        placeholder="Search"
                        type="search"
                      ></b-form-input>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col md="8" class="d-flex justify-content-end align-items-center">
                  <div class="alert-contacts-per-page-wrapper">
                    <img src="@/assets/icons/per-page.svg" alt="Per page" class="per-page-icon mr-2" />
                    <span>Per page : </span>
                    <div class="select-wrapper">
                      <b-form-select
                        class="alert-contacts-per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        @change="getAlertContacts"
                      >
                      </b-form-select>
                      <i class="icofont icofont-simple-down select-icon"></i>
                    </div>
                  </div>
                  <button class="alert-contacts-add-btn ml-3" @click="add_alerts_modal = true">
                    <img src="@/assets/icons/alert-bell-icon.svg" alt="Add Alert" class="add-alert-icon" />
                    Add Alert
                  </button>
                  <add-monitor-button 
                    class="ml-3" 
                    :icon-only="true" 
                    variant="green"
                  />
                </b-col>
              </b-row>
            </div>
              <div class="col-md-12" v-if="loading">
                <!-- <h6 class="sub-title mb-0 text-center">Loading...</h6> -->
                  <div class="loader-box">
                    <div class="loader-30"></div>
                  </div>
              </div> 
              <div v-else class="alert-contacts-table-container">
                <b-table
                  class="alert-contacts-table"
                  show-empty
                  stacked="md"
                  :items="items"
                  :filter="filter"
                  :fields="tablefields"
                  :per-page="perPage"
                  @filtered="onFiltered"
                  borderless
                >
                <!-- <template #table-caption>AlertContacts List.</template> -->

                <template #cell(index)="data">
                  <span class="alert-sr-number">{{ (currentPage - 1) * perPage + data.index + 1 }}</span>
                </template>

                <template #cell(name)="data">
                  <div class="cust_txt" :title="data.item.name">{{ data.item.name }}</div>
                </template>
                <template #cell(type)="data">
                  <div class="alert-type-badge">
                    <span class="type-dot"></span>
                    <span class="type-text">{{ getAlertTypeText(data.item.type) }}</span>
                  </div>
                </template>
                <template #cell(alertToUrl)="data">
                  <div class="res_text">{{ data.item.type == 4 ? webpushurl+'acid='+data.item._id : data.item.alertToUrl }}</div>
                </template>
                <template #cell(status)="data">
                    <div class="alert-status-toggle">
                        <label class="switch">
                        <input type="checkbox" :checked=data.item.status @change="statusUpdate(data.item)">
                        <span class="switch-state" :class="data.item.status?'status-active':'status-inactive'"></span>
                        </label>
                    </div>                 
                </template>
                <template #cell(isVerified)="data">
                  <button v-if="data.item.isVerified == true" class="test-notification-btn" @click="sendTestMessageAlert(data.item)">
                    <img src="@/assets/icons/alert-bell-icon.svg" alt="Notify" class="notification-icon alert-icon" />
                    Notify Now
                  </button>     
                  <button v-if="!data.item.isVerified && data.item.type != 5" class="verify-badge" @click="openOtpModal(data.item)">
                    <span class="verify-dots">
                      <span class="verify-dot verify-dot-1"></span>
                      <span class="verify-dot verify-dot-2"></span>
                      <span class="verify-dot verify-dot-3"></span>
                    </span>
                    Verify Now
                  </button>
                </template>
                 <!-- <template #cell(isFallback)="data">
                    <div class="media-body switch-outline">
                        <label class="switch">
                        <input type="checkbox" :checked=data.item.isFallback @change="fallbackUpdate(data.item)"><span class="switch-state" :class="data.item.isFallback?'bg-success':'bg-danger'"></span>
                        </label>
                    </div>                 
                </template> -->
                <template #cell(action)="data">
                  <div class="action-buttons">
                    <button class="action-btn" @click="deleteAlert(data.item._id)" title="Delete">
                      <img src="@/assets/icons/delete-icon.svg" alt="Delete" class="action-icon" />
                    </button>
                    <button class="action-btn" @click="editAlert(data.item)" title="Edit">
                      <img src="@/assets/icons/edit-icon.svg" alt="Edit" class="action-icon" />
                    </button>
                  </div>
                </template>
                </b-table>
                <!-- Pagination Component -->
                <div class="pagination-wrapper">
                  <pagination-component
                    :current-page="currentPage"
                    :per-page="perPage"
                    :total-items="totalRowsCount || totalRows"
                    :page-options="pageOptions"
                    @change-page="handlePageChange"
                    @update-per-page="handlePerPageChange"
                  />
                </div>
              </div>
        </div>
      </div>
    </div>
    <!-- Modals -->
    <b-modal id="modal-monitor" size="lg" @hidden="closeModal()" title="" class="theme-modal custom-modal" v-model="add_alerts_modal" no-close-on-backdrop hide-footer>
        <template #modal-header>
          <div class="custom-modal-header">
            <h5 class="custom-modal-title">{{ edit_alert ? 'Edit Alert' : 'Create Alert' }}</h5>
            <button class="custom-modal-close" @click="closeModal()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </template>
        <add-contact :add_alerts_modal="add_alerts_modal" @alertmodal="closeModal" :edit_alert="edit_alert" :alert_data="alert_data"></add-contact>
        <!-- No footer -->
    </b-modal>

    <b-modal id="verify-otp" size="" @hidden="getAlertContacts()" title="" class="theme-modal verify-modal" v-model="verify_otp_modal" no-close-on-backdrop hide-footer>
        <!-- Custom Header -->
        <template #modal-header>
          <div class="verify-modal-header">
            <img src="@/assets/icons/alert-verification.svg" alt="Verification" class="verify-modal-icon" />
            <h5 class="verify-modal-title">Verification</h5>
            <button class="verify-modal-close" @click="closeVerifyModal()" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </template> 
        <div v-if="verifyStep === 'instructions'">
          <div class="col-md-12 mt-3">
          <b-row>
            <div class="verify-instructions">
                <h6 class="verify-instructions-title">How its work ? follow below the steps</h6>
              <ol class="verify-instructions-list">
                  <li v-if="otp_data.type == 1">Click on below Send Verification Code Button.</li>
                  <li v-if="otp_data.type == 1">You will receive code on your registered mail id.</li>
                  <li v-if="otp_data.type == 1">Enter code and get verified</li>
                  <!-- <li v-if="otp_data.type == 2">Send a request to our skype id <span class="text-primary f-w-600">{{skypeid}}</span> and wait for a while.</li>
                  <li v-if="otp_data.type == 2">Click on Send Verification Code button.</li>
                  <li v-if="otp_data.type == 2">You will receive a verification code on your registered Skype id.</li>
                  <li v-if="otp_data.type == 2">Enter the code and your Skype account will get verified.</li> -->
                  <li v-if="otp_data.type == 3">Find Bot in telegram <a :href="'https://t.me/' + telegramBot" class="text-primary f-w-600" target="_blank">{{telegramBot}}</a>.</li>
                  <li v-if="otp_data.type == 3">Enter '/start'.</li>
                  <li v-if="otp_data.type == 3">After successfully subscribed on telegram click on given below Send Verification Code Button.</li>
                  <li v-if="otp_data.type == 3">You will receive otp code on telegram. Enter verification code and Submit to verified.</li>
                  <li v-if="otp_data.type == 3">If still did't receive verification code then please edit your Alert and verify username in related ID field.</li>
                  <li v-if="otp_data.type == 4">Copy below url and Open in device browser where you want notification</li>
                  <li v-if="otp_data.type == 6 || otp_data.type == 7">Click on below Send Verification Code Button.</li>
                  <li v-if="otp_data.type == 8">Click on Add to Slack button to verify.</li>
                  <li v-if="otp_data.type == 6 || otp_data.type == 7">You will receive code on your mobile number.</li>
                  <li v-if="otp_data.type == 6 || otp_data.type == 7">Enter code and get verified</li>
                  <li v-if="otp_data.type == 9">Click on below Send Verification Code Button.</li>
                  <li v-if="otp_data.type == 9">You will receive verification code on Zappier webhook.</li>
                  <li v-if="otp_data.type == 9">Enter code and get verified</li>
                  <li v-if="otp_data.type == 10">Click on below Send Verification Code Button.</li>
                  <li v-if="otp_data.type == 10">You will receive verification code on Zulip Bot.</li>
                  <li v-if="otp_data.type == 10">Enter code and get verified.</li>
                  <li v-if="otp_data.type == 11">Click on below Send Verification Code Button.</li>
                  <li v-if="otp_data.type == 11">You will receive verification code on your Teams channel.</li>
                  <li v-if="otp_data.type == 11">Enter code and get verified.</li>
              </ol>
            </div>
          </b-row>
          
          <!-- Web Push Verification -->
          <b-row v-if="otp_data.type == 4" class="mt-3">
            <b-col>
              <div class="verify-url-section">
                <p class="verify-url-label">Verification URL:</p>
                <div class="verify-url-wrapper">
                  <code class="verify-url-code">{{ webpushurl+'acid='+otp_data._id }}</code>
                  <button class="verify-copy-btn" @click="copyUrl(webpushurl+'acid='+otp_data._id)">
                    <img src="@/assets/icons/Copy.svg" alt="Copy" class="copy-icon" />
                    Copy URL
                  </button>
                </div>
              </div>
            </b-col>
          </b-row>
          
          <!-- Slack Verification -->
          <b-row v-if="otp_data.type == 8" class="mt-4">
            <b-col class="text-center">
              <a :href="slacVerifyurl" class="slack-add-btn">
                <img alt="Add to Slack" height="44" width="157" src="https://platform.slack-edge.com/img/add_to_slack.png" srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" />
              </a>
            </b-col>
          </b-row>
          
          <!-- Send Verification Code Button (not for Web Push or Slack) -->
          <b-row v-if="otp_data.type != 4 && otp_data.type != 8" class="mt-3">
              <b-col>
                <button class="verify-send-btn" @click="sendOTP()">
                  Send Verification Code
                  <img src="@/assets/icons/send-verification-code.svg" alt="Send" class="send-icon" />
                </button>
          </b-col>
          </b-row>
        </div>
            </div>
        <div v-else-if="verifyStep === 'code'">
          <div class="col-md-12 mt-3">
            <div class="text-center mb-3" style="font-size:16px;font-weight:500;">
              We have sent the verification code on your <span style="font-weight: 600;word-wrap:break-word;word-break:break-all;display:inline-block;max-width:100%;">{{ maskedContact() }}</span>
        </div>
            <div class="d-flex justify-content-center mb-3">
              <div class="d-flex gap-2" style="gap:12px;">
                <input v-for="(digit, idx) in codeInputs" :key="idx" :ref="'codeInput'+idx" maxlength="1" type="text" inputmode="numeric" pattern="[0-9]*" class="verify-otp-input" v-model="codeInputs[idx]" @input="onCodeInput(idx, $event)" @keydown="onCodeKeydown(idx, $event)" autocomplete="one-time-code" />
              </div>
        </div>
            <div class="text-center mb-3 verify-timer-text">
              <span v-if="!canResend">
                <img src="@/assets/icons/timer-icon.svg" alt="Timer" class="timer-icon" />
                00:{{ timer < 10 ? '0'+timer : timer }}
              </span>
              <span v-else>
                don't receive code <span class="verify-resend-link" @click="resendOTP()">Resend now <img src="@/assets/icons/resend-verification-code.svg" alt="Send" class="resend-icon" /></span>
              </span>
              </div>
            <div>
              <button class="verify-confirm-btn" :disabled="!isCodeComplete()" @click="verifyOtp()">
                Verify Now
            </button>
        </div>
        </div>
              </div>
        <!-- No footer -->
    </b-modal>
  </div>
</template>


<script>
import AlertController from "../../services/alertController";
import AddContact from "./AddAlerts.vue";
import Conf from '../../services/config';
import AddMonitorButton from ".././components/addMonitorButton.vue";
import PaginationComponent from "@/components/PaginationComponent.vue";
import { alertEvents } from '@/plugins/posthog-events';
let socket;
export default {
    name: 'AlertContact',
    components:{AddContact, AddMonitorButton, PaginationComponent},
    data(){
        return{
            input:{},
            verify_pin:false,
            otp_data:[],
            verify_otp_modal:false,
            alert_data:{},
            otploading:false,
            add_alerts_modal:false,
            edit_alert: false,
            items:[],
            totalRows:0,
            totalRowsCount: 0,
            filter:null,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 50],
            tablefields: [
                          { key: "index", label: "Sr.", sortable: false },
                          { key: "name", label: "Name", sortable: true },
                          { key: "alertToUrl", label: "Alert Recipient", sortable: false },
                          { key: "type", label: "Type", sortable: false },
                          { key: "status", label: "Status", sortable: false },
                          { key: "isVerified", label: "Verify Status", sortable: false },
                          // { key: "isFallback", label: "Use As Fallback", sortable: false },
                          { key: "action", label: "Action", sortable: false },
                        ],
            loading: false,
            alert_opt:[
              { value: null, text:'Please Select' },
              { value: '1', text:'Email' },
              // { value: '2', text:'Skype' },
              { value: '3', text:'Telegram' },
              { value: '4', text:'Web push' },
              { value: '5', text:'Webhook' },
              { value: '6', text:'Message' },
              { value: '7', text:'Call' },
              { value: '8', text:'Slack' },
              { value: '9', text:'Zappier webhook' },
              { value: '10', text: 'Zulip' },
              { value: '11', text: 'Teams' }
            ],
            telegramBot:'',
            webpushurl:'',
            slacVerifyurl:'',
            skypeid:'',
            userinfo:'',
            btn_class:'',
            isOtpEntered: false,
            invalid_otp_message: 'Please enter verification code',
            verifyStep: 'instructions', // 'instructions' or 'code'
            codeInputs: ['', '', '', '', '', ''],
            timer: 30,
            timerInterval: null,
            canResend: false,
        }
    },
    mounted(){
      this.$root.$data.alert_id = ''
      this.getAlertContacts()
      this.telegramBot = Conf.telegramBot
      this.webpushurl = Conf.webPushUrl
      this.slacVerifyurl = Conf.slacVerifyurl
      this.skypeid = Conf.skypebot
      this.userinfo = JSON.parse(window.localStorage.getItem('userinfo'))

      let pathName = this.$route.name
      if (pathName === 'Dashboard' || pathName === 'Incidents' || pathName === 'SubUser' || pathName === 'Profile') {
          this.btn_class = 'custom-btn-dark';
      } else {
          this.btn_class = 'add-monitor-btn-green';
      }
    },
    methods:{
        // async fallbackUpdate(data) {
        // let s = true
        // if(data.isFallback == true){
        //     s = false
        // }

        // if (data.isFallback == false) {
        //   data.isFallback = true;
        // } else {
        //   data.isFallback = false;
        // }

        // var payload = {"acid": data._id, "changePayload": {"isFallback":s}}
        // let response = await AlertController.editAlert(payload)
        // if(response.result){
        //     this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
        //     // this.getAlertContacts()
        // }
        // else{
        //     this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 3000});
        //     this.getAlertContacts()
        //   }
        // },
        async getAlertContacts(){
          this.loading = true;
            this.items = []
            let paginationQuery = '?currentPage='+this.currentPage+'&pageSize='+this.perPage
            let response = await AlertController.getAll(paginationQuery)
            console.log('Alert Contacts API Response:', response); // Debug log
            if (response.result) {
                this.items = response.data;
                // totalRows should be the count of current page items
                this.totalRows = this.items.length;
                // totalRowsCount should be the total count across all pages
                this.totalRowsCount = response.totalCount || response.total || response.count || 0;
                console.log('Alert Contacts - Items:', this.items.length, 'Total Count:', this.totalRowsCount); // Debug log
                
                // If API doesn't return total count and we have a full page, assume there might be more
                if (!this.totalRowsCount && this.items.length === this.perPage) {
                    // Set a high number to enable next button
                    this.totalRowsCount = this.currentPage * this.perPage + 1;
                } else if (!this.totalRowsCount) {
                    // If less than perPage items, this is likely the last page
                    this.totalRowsCount = (this.currentPage - 1) * this.perPage + this.items.length;
                }
            }
            if(this.$root.$data.alert_id != ''){
              let data = this.items.filter((t)=> t._id===this.$root.$data.alert_id)
              if(data[0].type != 5){
              this.openOtpModal(data[0])
            }
              this.$root.$data.alert_id = ''
            }
            this.loading = false;

            try {
              if (socket.readyState == WebSocket.OPEN) {
                socket.close();
              }
            } catch (e) {
              console.log("ERROR: error in check status" + e);
            }
            socket = new WebSocket(
              process.env.VUE_APP_SOCKETURL
            );
            socket.onopen = function () {
              console.log("[open] Connection established");
              console.info("Sending to server");
              this.userinfo = JSON.parse(window.localStorage.getItem('userinfo'))
              let data = {
                userid: this.userinfo.userid
              };
              socket.send(JSON.stringify(data));
            };
            socket.onerror = function (error) {
              console.error("error:", error);
              throw new Error("Unable to Open Socket");
            };
            socket.onclose = function () {
              console.log("[close] connection closing");
            };
            socket.onmessage = async function () {
              try {
                this.getAlertContacts()
              } catch (e) {
                console.log(e);
              }
            }.bind(this);
        },
        async sendTestMessageAlert(alertDetail) {
         const alertId = alertDetail["_id"]
         let response = await AlertController.sendTestMessage({"acid": alertId});

         // Track alert test in PostHog
         const alertType = alertDetail.alertType || alertDetail.type || 'unknown';
         alertEvents.channelTested(alertType, response.result);

         if(response.result){
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
          }else{
          this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
        }
          return
        },
        async deleteAlert(id){
          if(confirm("Are you sure want to delete?")){
          this.loading = true;
          let response = await AlertController.deleteAlerts({"acid": id});
          if(response.result){
            // Track alert channel removal in PostHog
            alertEvents.channelRemoved('alert');
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
            this.getAlertContacts()
          }
          else{
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 3000});
            this.getAlertContacts()
          }
        }
        },
        editAlert(data){
          this.add_alers_modal = false
          this.add_alerts_modal = true
          this.alert_data = data;
          this.edit_alert = true;
        },
        closeModal(){
          this.add_alerts_modal = false
          this.edit_alert = false;
          this.getAlertContacts();
      },
      openOtpModal(data){
        if(this.userinfo.role == 'subUser' && this.userinfo.access == 0) {
          this.$toasted.show('Insufficient permission to perform this action. contact your account manager', {theme: 'outline',position: "bottom-center", type: 'error', duration: 3000});
          return
        } else {
          this.otp_data = []
          this.otp_data = data
          this.verify_otp_modal = true
          this.verify_pin = false
          this.verifyStep = 'instructions';
          this.codeInputs = ['', '', '', '', '', ''];
          this.timer = 30;
          this.canResend = false;
          if (this.timerInterval) clearInterval(this.timerInterval);
        }
      },
      async sendOTP() {
        this.otploading = true;
        var payload = {"contactId": this.otp_data._id};
        let response = await AlertController.sendOtp(payload);
          if(response.result){
            this.$toasted.show('Verification code has been sent', {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
          this.verify_pin = true;
          this.verifyStep = 'code';
          this.startTimer();
          }
          else{
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 3000});
          }
        this.otploading = false;
      },
      resendOTP() {
        if (!this.canResend) return;
        this.sendOTP();
      },
      startTimer() {
        this.timer = 30;
        this.canResend = false;
        if (this.timerInterval) clearInterval(this.timerInterval);
        this.timerInterval = setInterval(() => {
          if (this.timer > 0) this.timer--;
          if (this.timer === 0) {
            this.canResend = true;
            clearInterval(this.timerInterval);
          }
        }, 1000);
      },
      onCodeInput(index, event) {
        let value = event.target.value.replace(/\D/g, '');
        if (value.length > 1) value = value.slice(-1);
        this.$set(this.codeInputs, index, value);
        // Auto-advance
        if (value && index < 5) {
          this.$nextTick(() => {
            const next = this.$refs[`codeInput${index+1}`];
            if (next && next[0]) next[0].focus();
          });
        }
      },
      onCodeKeydown(index, event) {
        // Handle backspace
        if (event.key === 'Backspace') {
          // If current input is empty and not the first input, move to previous
          if (!this.codeInputs[index] && index > 0) {
            event.preventDefault();
            const prev = this.$refs[`codeInput${index-1}`];
            if (prev && prev[0]) {
              prev[0].focus();
              // Clear the previous input value
              this.$set(this.codeInputs, index - 1, '');
            }
          }
        }
        // Handle arrow keys
        else if (event.key === 'ArrowLeft' && index > 0) {
          event.preventDefault();
          const prev = this.$refs[`codeInput${index-1}`];
          if (prev && prev[0]) prev[0].focus();
        }
        else if (event.key === 'ArrowRight' && index < 5) {
          event.preventDefault();
          const next = this.$refs[`codeInput${index+1}`];
          if (next && next[0]) next[0].focus();
        }
      },
      isCodeComplete() {
        return this.codeInputs.every(d => d.length === 1);
      },
      maskedContact() {
        let str = this.otp_data.alertToUrl || this.otp_data.email || '';
        if (!str) return '';
        // Return full email/url without masking
        return str;
       },
       async verifyOtp(){
        this.otploading = true
        const otpCode = this.codeInputs.join('');
        let payload = {"contactId":this.otp_data._id ,"otp": otpCode}
        let response = await AlertController.verifyOtp(payload)
        if(response.result){
          this.$toasted.show('Successfully verified', {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
          this.input = {}
          this.verify_pin = false
          this.verify_otp_modal = false
          this.getAlertContacts()
        }
        else{
          this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
        }
        this.otploading = false
       },
       copyUrl(txt){
          const el = document.createElement('textarea');
          el.addEventListener('focusin', e => e.stopPropagation());
          el.value = txt;
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
          this.$toasted.show('URL copied to clipboard.', {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
        },
      validateOtp() {
        this.isOtpEntered = true;
        if (!this.input.otp || this.input.otp.length == '') {
          this.invalid_otp_message = 'Please enter verification code';
        } else {
          this.invalid_otp_message = '';
        }
      },
      handlePageChange(direction) {
        if (direction === 'prev' && this.currentPage > 1) {
          this.currentPage--;
        } else if (direction === 'next') {
          this.currentPage++;
        } else if (typeof direction === 'number') {
          this.currentPage = direction;
        }
        this.getAlertContacts();
      },
      handlePerPageChange(newPerPage) {
        this.perPage = newPerPage;
        this.currentPage = 1;
        this.getAlertContacts();
      },
      closeVerifyModal() {
        this.verify_otp_modal = false;
        this.getAlertContacts();
        this.verifyStep = 'instructions';
        this.codeInputs = ['', '', '', '', '', ''];
        this.timer = 30;
        this.canResend = false;
        if (this.timerInterval) clearInterval(this.timerInterval);
      },
      async statusUpdate(data){
        var s = true
        if(data.status == true){
            s = false
        }
        if (data.status == false) {
          data.status = true;
        } else {
          data.status = false;
        }
        var payload = {"acid": data._id, "changePayload": {"status":s}}
        let response = await AlertController.editAlert(payload)
        if(response.result){
          let toastMessage = data.status ? "Activated successfully" : "Deactivated successfully";
          this.$toasted.show(toastMessage || response.message, { 
              theme: 'outline', 
              position: "bottom-center", 
              type: 'success', 
              duration: 2000 
          });
        }
        else{
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 3000});
            this.getAlertContacts()
        }
      },
      getAlertTypeText(type) {
        // Convert type to string for consistent comparison
        const typeStr = String(type);
        
        // Handle Skype type (2) which is commented out
        if (typeStr === '2') {
          return 'Skype';
        }
        
        // Find the alert option by matching value (as string)
        const alertOption = this.alert_opt.find(opt => opt.value === typeStr);
        if (alertOption) {
          return alertOption.text;
        }
        
        return 'Unknown';
      },
      onFiltered(filteredItems) {
        // Update the number of records whenever filtering changes
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      }
    }
}

</script>

<style scoped>
/* Layout Styles */
.alert-contacts-page-wrapper {
  width: 100%;
  padding: 0;
}

.alert-contacts-header {
  margin-bottom: 20px;
  margin-top: 30px;
  width: 100%;
}

/* Search Bar Styles */
.alert-contacts-search-wrapper {
  position: relative;
}

.alert-contacts-search-wrapper .input-group {
  border: 1px solid #D0D5DD;
  border-radius: 12px;
  overflow: hidden;
  background: #FFFFFF;
  padding: 0px;
}

.alert-contacts-search-wrapper .input-group-text {
  background: #FFFFFF;
  border: none;
  padding: 3px 12px;
}

.alert-contacts-search-wrapper .search-icon {
  color: #344054;
  font-size: 18px;
}

.alert-contacts-search-input {
  background: #FFFFFF;
  border: none;
  padding: 3px 12px 3px 8px;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #111827;
}

.alert-contacts-search-input:focus {
  box-shadow: none;
  background: transparent;
}

.alert-contacts-search-input::placeholder {
  color: #9CA3AF;
}

/* Per Page Styles */
.alert-contacts-per-page-wrapper {
  display: flex;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid #D0D5DD;
  border-radius: 10px;
  padding: 3px 16px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: #344054;
  height: 47px;
}

.alert-contacts-per-page-wrapper .per-page-icon {
  width: 16px;
  height: 18px;
}

.alert-contacts-per-page-wrapper .select-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
}

.alert-contacts-per-page-select {
  width: auto;
  border: none;
  background: transparent;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Inter', sans-serif;
  padding: 0 20px 0 5px;
  color: #344054;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

.alert-contacts-per-page-wrapper .select-icon {
  position: absolute;
  right: 2px;
  pointer-events: none;
  color: #344054;
}

/* Sr. Number Styles */
.alert-sr-number {
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  color: #3A3A3A;
}

/* Add Alert Button */
.alert-contacts-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  background: #2FB234;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 500;
  color: #FFFFFF;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  height: 48px;
}

.alert-contacts-add-btn:hover {
  background: #28A22C;
}

.add-alert-icon {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

/* Table Container Styles */
.alert-contacts-table-container {
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 20px;
  overflow: hidden;
  margin: 0 0 20px 0;
  width: 100%;
}

/* Pagination wrapper inside table container */
.alert-contacts-table-container .pagination-wrapper {
  background: #FFFFFF;
  border-radius: 0 0 20px 20px;
  padding: 0;
  border-top: none !important;
}

/* Remove any top border from pagination component and its children */
.alert-contacts-table-container .pagination-wrapper > *,
.alert-contacts-table-container .pagination-wrapper .custom-pagination {
  border-top: none !important;
  margin-top: 0 !important;
}

.alert-contacts-table {
  margin-bottom: 0;
  width: 100%;
  border: none !important;
  border-radius: 0 !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  overflow: visible;
}

.alert-contacts-table >>> thead th {
  background: #FFFFFF;
  padding: 30px 20px 15px 20px!important;
  font-family: 'Poppins', sans-serif;
  font-weight: 600 !important;
  font-size: 18px;
  color: #161616 !important;
  border-bottom: 1px solid #E5E7EB !important;
  border-top: none !important;
}

.alert-contacts-table >>> tbody tr td {
  padding: 15px 20px !important;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  color: #161616;
  border-bottom: 1px solid #E5E7EB !important;
  vertical-align: middle;
}

.alert-contacts-table >>> tbody tr:last-child td {
  border-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.alert-contacts-table >>> tbody tr:last-child td:first-child {
  border-bottom-left-radius: 0 !important;
  border-radius: 0 !important;
}

.alert-contacts-table >>> tbody tr:last-child td:last-child {
  border-bottom-right-radius: 0 !important;
  border-radius: 0 !important;
}

/* Remove radius from table tbody */
.alert-contacts-table >>> tbody {
  border-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

/* Status Toggle */
.alert-status-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.alert-status-toggle .switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 44px;
  height: 24px;
  vertical-align: middle;
}

.alert-status-toggle .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.alert-status-toggle .switch-state {
  position: absolute;
  cursor: pointer;
  top: 75%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  height: 24px;
  transition: .4s;
  border-radius: 34px;
}

.alert-status-toggle .switch-state:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}

.alert-status-toggle .status-active {
  background-color: #10B981 !important;
}

.alert-status-toggle .status-inactive {
  background-color: #E5E7EB;
}

.alert-status-toggle input:checked + .switch-state:before {
  transform: translateX(20px);
}

.alert-status-toggle input:not(:checked) + .switch-state {
  background-color: #E5E7EB !important;
}

.alert-status-toggle input:checked + .switch-state {
  background-color: #10B981 !important;
}

/* Test Notification Button */
.test-notification-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 5px 10px;
  background: #007BFF;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #FFFFFF;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 32px;
  white-space: nowrap;
}

.test-notification-btn:hover {
  background: #0056D2;
}

.notification-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.alert-icon {
  display: inline-block;
  animation: shake 5s ease-in-out infinite;
}

@keyframes shake {
  0%, 90% { transform: rotate(0); }
  92% { transform: rotate(-15deg); }
  94% { transform: rotate(15deg); }
  96% { transform: rotate(-10deg); }
  98% { transform: rotate(10deg); }
  100% { transform: rotate(0); }
}

/* Verify Badge */
.verify-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 10px;
  background: rgba(231, 0, 0, 0.1);
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #F20707;
  font-family: 'Poppins', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 32px;
  white-space: nowrap;
}

.verify-badge:hover {
  background: rgba(231, 0, 0, 0.15);
}

.verify-dots {
  display: flex;
  align-items: center;
  gap: 2px;
  width: 14px;
  height: 14px;
  position: relative;
}

.verify-dot {
  position: absolute;
  border-radius: 50%;
  background: #F20707;
}

.verify-dot-1 {
  width: 14px;
  height: 14px;
  opacity: 0.2;
  top: 0;
  left: 0;
}

.verify-dot-2 {
  width: 10px;
  height: 10px;
  opacity: 0.1;
  top: 2px;
  left: 2px;
}

.verify-dot-3 {
  width: 8px;
  height: 8px;
  opacity: 1;
  top: 3px;
  left: 3px;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #6B7280;
  font-size: 18px;
  transition: all 0.2s ease;
  border-radius: 4px;
}

.action-btn:hover {
  background: #F3F4F6;
  color: #374151;
}

.action-icon {
  width: 20px;
  height: 20px;
}

/* Alert Type Badge */
.alert-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px 2px 6px;
  background: rgba(41, 51, 64, 0.13);
  border-radius: 16px;
  font-size: 14px;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
  color: #293340;
  white-space: nowrap;
}

.alert-type-badge .type-dot {
  width: 8px;
  height: 8px;
  background: #293340;
  border-radius: 50%;
  position: relative;
}

.alert-type-badge .type-dot::before {
  content: '';
  position: absolute;
  width: 6px;
  height: 6px;
  background: #293340;
  border-radius: 50%;
  top: 1px;
  left: 1px;
}

.alert-type-badge .type-text {
  font-size: 14px;
  font-weight: 500;
  color: #293340;
}


/* Verify Modal Styles */
.verify-modal .modal-dialog {
  max-width: 450px !important;
}

.verify-modal .modal-content {
  border-radius: 8px;
  border: none;
}

.verify-modal .modal-header {
  border-bottom: none;
  padding: 30px 30px 0 30px;
}

.verify-modal-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  position: relative;
}

.verify-modal-close {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 28px;
  font-weight: 300;
  line-height: 1;
  color: #6B7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.verify-modal-close:hover {
  background: #F3F4F6;
  color: #374151;
}

.verify-modal-icon {
  width: 24px;
  height: 24px;
}

.verify-modal-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 20px;
  color: #161616;
  margin: 0;
}

.verify-modal .modal-body {
  padding: 30px;
}

.verify-instructions {
  margin-bottom: 30px;
}

.verify-instructions-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #161616;
  margin-bottom: 15px;
}

.verify-instructions-list {
  margin: 0;
  padding-left: 20px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #6B7280;
  line-height: 1.6;
}

.verify-instructions-list li {
  margin-bottom: 8px;
}

.verify-url-code {
  display: block;
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  padding: 12px;
  margin-top: 10px;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: #374151;
  word-break: break-all;
}

/* Send Verification Code Button */
.verify-send-btn {
  background: #2FB234;
  border: none;
  border-radius: 12px;
  padding: 12px 24px;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.verify-send-btn:hover {
  background: #28A02D;
  transform: translateY(-1px);
}

.verify-send-btn .send-icon {
  width: 20px;
  height: 20px;
}


/* Verify Confirm Button */
.verify-confirm-btn {
  background: #2FB234;
  border: none;
  border-radius: 12px;
  padding: 12px 30px;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.verify-confirm-btn:hover:not(:disabled) {
  background: #28A02D;
}

.verify-confirm-btn:disabled {
  background: #7D8699;
  cursor: not-allowed;
  opacity: 1;
}

/* OTP Input Fields */
.verify-otp-input {
  width: 48px;
  height: 48px;
  font-size: 24px;
  font-weight: 600;
  border-radius: 12px;
  border: 1px solid rgba(210, 227, 251, 1);
  text-align: center;
  margin-right: 8px;
  transition: all 0.2s ease;
  padding: 0 4px;
}

.verify-otp-input:focus {
  outline: none;
  border-color: #2FB234;
  box-shadow: 0 0 0 2px rgba(47, 178, 52, 0.25);
}

/* Resend Link */
.verify-resend-link {
  color: #007BFF;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-family: 'Poppins', sans-serif;
}

.verify-resend-link .resend-icon {
  width: 16px;
  height: 16px;
}

/* Timer Icon */
.timer-icon {
  width: 18px;
  height: 18px;
  margin-right: 4px;
  margin-bottom: 3px;
  vertical-align: text-bottom;
  filter: brightness(0) saturate(100%) invert(51%) sepia(8%) saturate(438%) hue-rotate(181deg) brightness(93%) contrast(87%);
}

/* Verification Sent Message */
.verify-sent-message {
  font-size: 16px;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
}

.verify-sent-contact {
  font-weight: 600;
  color: #161616;
}

/* Timer Text */
.verify-timer-text {
  font-size: 16px;
  color: #667085;
  font-family: 'Poppins', sans-serif;
}

/* Web Push Verification Styles */
.verify-url-section {
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  padding: 20px;
  width: 100%;
}

.verify-url-label {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #374151;
  margin-bottom: 12px;
}

.verify-url-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.verify-url-code {
  background: #FFFFFF;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  padding: 12px 16px;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: #111827;
  word-break: break-all;
  display: block;
  width: 100%;
}

.verify-copy-btn {
  background: #2FB234;
  border: none;
  border-radius: 8px;
  padding: 10px 20px;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: auto;
  align-self: center;
}

.verify-copy-btn:hover {
  background: #28A02D;
  transform: translateY(-1px);
}

.verify-copy-btn .copy-icon {
  width: 16px;
  height: 16px;
  filter: brightness(0) invert(1);
}

/* Slack Verification Styles */
.slack-add-btn {
  display: inline-block;
  transition: transform 0.2s ease;
}

.slack-add-btn:hover {
  transform: translateY(-2px);
}

/* Custom Modal Styles - Similar to Verify Modal */
.custom-modal .modal-header {
  border-bottom: none;
  padding: 30px 30px 0 30px;
}

.custom-modal-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  position: relative;
}

.custom-modal-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 26px;
  color: #3A3A3A;
  margin: 0;
  text-align: center;
}

.custom-modal-close {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 28px;
  font-weight: 300;
  line-height: 1;
  color: #6B7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.custom-modal-close:hover {
  background: #F3F4F6;
  color: #374151;
}

.custom-modal .modal-body {
  padding: 30px;
  font-family: 'Poppins', sans-serif;
}

/* Close button in modal footer */
.verify-modal .modal-footer {
  border-top: 1px solid #E5E7EB;
  padding: 20px 30px;
}

.verify-modal .modal-footer button {
  background: #F3F4F6;
  border: none;
  border-radius: 6px;
  padding: 10px 24px;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #6B7280;
  cursor: pointer;
  transition: all 0.2s ease;
}

.verify-modal .modal-footer button:hover {
  background: #E5E7EB;
}

/* Input field in verify modal */
.verify-modal input.form-control {
  border: 1px solid #E5E7EB;
  border-radius: 6px;
  padding: 12px 16px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #374151;
}

.verify-modal input.form-control:focus {
  border-color: #2FB234;
  border-radius: 12px;
  box-shadow: 0 0 0 0.2rem rgba(47, 178, 52, 0.25);
}

.verify-modal .invalid-feedback {
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
}

/* Custom text truncation */
.cust_txt {
  max-width: 12em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}

/* Responsive */
@media screen and (max-width: 1400px) {
  .cust_txt {
    max-width: 10em;
  }
}

@media screen and (max-width: 1200px) {
  .cust_txt {
    max-width: 8em;
  }
}

@media screen and (max-width: 992px) {
  .cust_txt {
    max-width: 6em;
  }
}

@media screen and (max-width: 768px) {
  .cust_txt {
    max-width: 5em;
  }
  .alert-contacts-header .col-md-4,
  .alert-contacts-header .col-md-8 {
    margin-bottom: 15px;
  }
  
  .alert-contacts-header .col-md-8 {
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .alert-contacts-per-page-wrapper,
  .alert-contacts-action-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>

<style>
.bg-danger{
  background-color: #E70000 !important;
}

</style>